import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Grid, Card, CardContent, Chip, Button, Avatar, Switch,
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Alert, Divider, IconButton, Tooltip,
  Select, MenuItem, FormControl, InputLabel, Tab, Tabs,
  Stepper, Step, StepLabel
} from '@mui/material';
import { InputAdornment } from '@mui/material';
import Layout from '../components/Layout';
import ExpandableTable from '../components/ExpandableTable';
import FileUpload from '../components/FileUpload';
import { projectService } from '../services/api';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import BusinessIcon from '@mui/icons-material/Business';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';

const TRADES = [
  'Soil Engineer','Site Services','Demo','Survey','Civil','Foundation',
  'Framing','Plumbing','HVAC','PG&E / Utilities','Roof','Stucco',
  'Structural','Architectural','Electrical','Insulation','Drywall',
  'Flooring','Painting','Landscaping','Concrete','Windows & Doors',
  'Cabinets & Millwork','Tile & Stone','Masonry','Supplier','Other'
];

const STEPS = ['Basic Info', 'License & Insurance', 'Payment', 'Review'];

const statusConfig = {
  invited:          { color: '#e3f2fd', text: '#1565c0', label: 'Invited' },
  pending_approval: { color: '#fff3e0', text: '#e65100', label: 'Pending Approval' },
  approved:         { color: '#e8f5e9', text: '#2e7d32', label: 'Approved ✓' },
  rejected:         { color: '#ffebee', text: '#c62828', label: 'Rejected' },
  inactive:         { color: '#f5f5f5', text: '#9e9e9e', label: 'Inactive' },
};

const emptyManual = {
  project_id: '', company_name: '', contact_name: '', email: '', phone: '',
  address: '', city: '', state: '', zip: '', trade_specialty: '',
  license_number: '', license_expiry: '', bank_name: '', account_type: 'checking',
  routing_number: '', account_number_last4: '', payment_method: 'check', notes: ''
};

const emptyInvite = {
  project_id: '', company_name: '', contact_name: '',
  email: '', phone: '', trade_specialty: '', trade_specialties: [], notes: '', visible_to_gc: true, photo_url: ''
};

export default function Vendors() {
  const { user } = useAuth();
  const [vendors, setVendors] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('all');
  const [gcVisibility, setGcVisibility] = useState('all');
  const [search, setSearch] = useState('');
  const [tab, setTab] = useState(0);
  const [inviteDialog, setInviteDialog] = useState(false);
  const [manualDialog, setManualDialog] = useState(false);
  const [manualStep, setManualStep] = useState(0);
  const [vendorPhoto, setVendorPhoto] = useState([]);
  const [tradeOptions, setTradeOptions] = useState([]);
  const [editPhoto, setEditPhoto] = useState([]);
  const [viewDialog, setViewDialog] = useState({ open: false, vendor: null });
  const [alert, setAlert] = useState({ show: false, message: '', severity: 'success' });
  const [loading, setLoading] = useState(false);
  const [inviteForm, setInviteForm] = useState(emptyInvite);
  const [manualForm, setManualForm] = useState(emptyManual);
  const [insuranceFiles, setInsuranceFiles] = useState([]);
  const [editDialog, setEditDialog] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [w9Files, setW9Files] = useState([]);
useEffect(() => {
  api.get('/settings/trades')
      .then(r => setTradeOptions((r.data || []).filter(t => t.is_active !== false).map(t => t.name)))
      .catch(() => {});
  }, []);

  
  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const [vendorRes, projRes] = await Promise.all([api.get('/vendors'), projectService.getAll()]);
      setVendors(vendorRes.data);
      setProjects(projRes.data);
      if (projRes.data.length > 0) {
        setInviteForm(f => ({ ...f, project_id: projRes.data[0].id }));
        setManualForm(f => ({ ...f, project_id: projRes.data[0].id }));
      }
    } catch (err) {}
  };

  const handleInvite = async () => {
    setLoading(true);
    try {
      await api.post('/vendors/invite', inviteForm);
      setInviteDialog(false);
      setInviteForm(emptyInvite);
      showAlert(`Invitation sent to ${inviteForm.email}!`, 'success');
      fetchData();
    } catch (err) { showAlert('Failed to send invitation', 'error'); }
    setLoading(false);
  };

  const handleManualSubmit = async () => {
    if (!manualForm.contact_name || !manualForm.phone) {
      alert('Contact name and phone number are required');
      return;
    }
    setLoading(true);
    try {
      const inviteRes = await api.post('/vendors/invite', {
        project_id: manualForm.project_id,
        company_name: manualForm.company_name,
        contact_name: manualForm.contact_name,
        email: manualForm.email,
        phone: manualForm.phone,
        trade_specialty: manualForm.trade_specialty,
        trade_specialties: manualForm.trade_specialties||[],
        visible_to_gc: manualForm.visible_to_gc !== false,
        photo_url: vendorPhoto.length > 0 ? (vendorPhoto[0].url || vendorPhoto[0].gcsUrl) : undefined,
        notes: manualForm.notes,
      });
      const vendorToken = inviteRes.data.onboarding_token;
      await api.put(`/vendors/onboarding/${vendorToken}`, {
        ...manualForm,
        insurance_cert_url: insuranceFiles[0]?.url || '',
        w9_url: w9Files[0]?.url || '',
      });
      await api.put(`/vendors/${inviteRes.data.id}/approve`);
      setManualDialog(false);
      setManualStep(0);
      setManualForm({ ...emptyManual, project_id: projects[0]?.id || '' });
      setInsuranceFiles([]);
      setW9Files([]);
      showAlert('Vendor added and approved successfully!', 'success');
      fetchData();
    } catch (err) { 
      console.error('Full error:', err);
      console.error('Response:', err.response?.data);
      showAlert('Failed to add vendor: ' + (err.response?.data?.error || err.message), 'error'); 
    }
    setLoading(false);
  };

  const handleApprove = async (vendor) => {
    try {
      await api.put(`/vendors/${vendor.id}/approve`);
      setVendors(vendors.map(v => v.id === vendor.id ? { ...v, status: 'approved' } : v));
      setViewDialog({ open: false, vendor: null });
      showAlert(`${vendor.company_name} approved!`, 'success');
    } catch (err) { showAlert('Failed to approve vendor', 'error'); }
  };

  const handleActivate = async (vendor) => {
    try {
      await api.put(`/vendors/${vendor.id}`, { ...vendor, status: 'approved' });
      setVendors(vendors.map(v => v.id === vendor.id ? { ...v, status: 'approved' } : v));
      showAlert(`${vendor.company_name} reactivated!`, 'success');
    } catch (err) { showAlert('Failed to activate vendor', 'error'); }
  };

  const handleDeactivate = async (vendor) => {
    if (!window.confirm(`Deactivate ${vendor.company_name}? They will no longer appear as active.`)) return;
    try {
      await api.put(`/vendors/${vendor.id}`, { ...vendor, status: 'inactive' });
      setVendors(vendors.map(v => v.id === vendor.id ? { ...v, status: 'inactive' } : v));
      showAlert(`${vendor.company_name} deactivated`, 'success');
    } catch (err) { showAlert('Failed to deactivate vendor', 'error'); }
  };

  const handleUpdate = async () => {
    setLoading(true);
    try {
      await api.put(`/vendors/${editForm.id}`, editForm);
      setVendors(vendors.map(v => v.id === editForm.id ? { ...v, ...editForm } : v));
      setEditDialog(false);
      showAlert('Vendor updated successfully!', 'success');
    } catch (err) { showAlert('Failed to update vendor', 'error'); }
    setLoading(false);
  };

  const showAlert = (message, severity) => {
    setAlert({ show: true, message, severity });
    setTimeout(() => setAlert({ show: false, message: '', severity: 'success' }), 4000);
  };

  const filtered = vendors.filter(v => {
    const matchesProject = selectedProject === 'all' || v.project_id === selectedProject;
    const matchesGcVis = gcVisibility === 'all'
      || (gcVisibility === 'visible' && v.visible_to_gc !== false)
      || (gcVisibility === 'hidden' && v.visible_to_gc === false);
    const matchesSearch = v.company_name?.toLowerCase().includes(search.toLowerCase()) ||
      v.contact_name?.toLowerCase().includes(search.toLowerCase()) ||
      v.trade_specialty?.toLowerCase().includes(search.toLowerCase());
    const matchesTab = 
      (tab === 0 && v.status !== 'inactive') ||
      (tab === 1 && v.status === 'approved') ||
      (tab === 2 && v.status === 'pending_approval') ||
      (tab === 3 && v.status === 'invited') ||
      (tab === 4 && v.status === 'inactive');
    return matchesProject && matchesSearch && matchesTab && matchesGcVis;
  }).sort((a, b) => (a.company_name || '').localeCompare(b.company_name || ''));

  const counts = {
    all: vendors.filter(v => v.status !== 'inactive').length,
    approved: vendors.filter(v => v.status === 'approved').length,
    pending: vendors.filter(v => v.status === 'pending_approval').length,
    invited: vendors.filter(v => v.status === 'invited').length,
    inactive: vendors.filter(v => v.status === 'inactive').length,
  };

  const formatPhone = (val) => {
    const digits = val.replace(/\D/g, '').slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0,3)}-${digits.slice(3)}`;
    return `${digits.slice(0,3)}-${digits.slice(3,6)}-${digits.slice(6)}`;
  };

  return (
    <Layout>
      {alert.show && <Alert severity={alert.severity} sx={{ mb: 3, borderRadius: 2 }}>{alert.message}</Alert>}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a237e' }}>Vendors</Typography>
          <Typography variant="body2" sx={{ color: '#666' }}>Manage contractors and suppliers for your projects</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" startIcon={<BusinessIcon />}
            onClick={() => { setManualDialog(true); setManualStep(0); setManualForm({ ...emptyManual, project_id: projects[0]?.id || '' }); }}
            sx={{ borderRadius: 2, px: 3, borderColor: '#1a237e', color: '#1a237e' }}>
            Add Manually
          </Button>
          <Button variant="contained" startIcon={<PersonAddIcon />} onClick={() => setInviteDialog(true)}
            sx={{ bgcolor: '#1a237e', borderRadius: 2, px: 3 }}>
            Invite Vendor
          </Button>
        </Box>
      </Box>

      {/* Summary Cards */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[
          { label: 'Total Vendors', value: counts.all, bg: 'linear-gradient(135deg, #1a237e, #283593)' },
          { label: 'Approved', value: counts.approved, bg: 'linear-gradient(135deg, #2e7d32, #43a047)' },
          { label: 'Pending Approval', value: counts.pending, bg: 'linear-gradient(135deg, #e65100, #f57c00)' },
          { label: 'Invited', value: counts.invited, bg: 'linear-gradient(135deg, #1565c0, #1976d2)' },
        ].map((card, i) => (
          <Grid item xs={6} md={3} key={i}>
            <Card elevation={0} sx={{ borderRadius: 3, background: card.bg, color: 'white' }}>
              <CardContent sx={{ py: 2 }}>
                <Typography variant="h4" sx={{ fontWeight: 800 }}>{card.value}</Typography>
                <Typography variant="body2" sx={{ opacity: 0.8 }}>{card.label}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Filters */}
      <Card elevation={0} sx={{ borderRadius: 3, border: '1px solid #e8eaf6', mb: 3 }}>
        <Box sx={{ borderBottom: '1px solid #e8eaf6' }}>
          <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ px: 2 }}>
            <Tab label={`All (${counts.all})`} />
            <Tab label={`Approved (${counts.approved})`} />
            <Tab label={`Pending (${counts.pending})`} />
            <Tab label={`Invited (${counts.invited})`} />
            <Tab label={`Inactive (${counts.inactive})`} />
          </Tabs>
        </Box>
        <Box sx={{ p: 2, display: 'flex', gap: 2 }}>
          <TextField placeholder="Search vendors..." value={search} onChange={e => setSearch(e.target.value)}
            size="small" sx={{ flexGrow: 1, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon sx={{ color: '#999', fontSize: 18 }} /></InputAdornment> }} />
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Project</InputLabel>
            <Select value={selectedProject} onChange={e => setSelectedProject(e.target.value)} label="Project" sx={{ borderRadius: 2 }}>
              <MenuItem value="all">All Projects</MenuItem>
              {projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
            </Select>
          </FormControl>
          {user?.role !== 'general_contractor' && (
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <InputLabel>GC Visibility</InputLabel>
              <Select value={gcVisibility} onChange={e => setGcVisibility(e.target.value)} label="GC Visibility" sx={{ borderRadius: 2 }}>
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="visible">GC Visible</MenuItem>
                <MenuItem value="hidden">GC Hidden</MenuItem>
              </Select>
            </FormControl>
          )}
        </Box>
      </Card>

      <ExpandableTable
        rows={filtered}
        emptyMessage="No vendors match the current filters."
        columns={[
          {
            key: 'company_name',
            label: 'Company',
            render: (v) => (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
                <Avatar src={v.photo_url || ''} sx={{ bgcolor: '#1a237e', width: 32, height: 32, fontSize: 14 }}>
                  {v.company_name?.[0]}
                </Avatar>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: '#1a237e' }} noWrap>
                    {v.company_name}
                  </Typography>
                  {v.contact_name && (
                    <Typography variant="caption" sx={{ color: '#888' }} noWrap>{v.contact_name}</Typography>
                  )}
                </Box>
              </Box>
            )
          },
          {
            key: 'trade_specialty',
            label: 'Trade',
            width: 180,
            render: (v) => {
              const trades = v.trade_specialties?.length > 0 ? v.trade_specialties : v.trade_specialty ? [v.trade_specialty] : [];
              return (
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                  {trades.slice(0, 2).map(t => (
                    <Chip key={t} label={t} size="small" sx={{ bgcolor: '#e8eaf6', color: '#1a237e', height: 20, fontSize: 11 }} />
                  ))}
                  {trades.length > 2 && (
                    <Chip label={'+' + (trades.length - 2)} size="small" sx={{ bgcolor: '#f5f5f5', color: '#666', height: 20, fontSize: 11 }} />
                  )}
                </Box>
              );
            }
          },
          {
            key: 'contact',
            label: 'Contact',
            render: (v) => (
              <Box sx={{ minWidth: 0 }}>
                {v.email && (
                  <Typography variant="caption" sx={{ display: 'block', color: '#555' }} noWrap>{v.email}</Typography>
                )}
                {v.phone && (
                  <Typography variant="caption" sx={{ display: 'block', color: '#888' }}>{v.phone}</Typography>
                )}
              </Box>
            )
          },
          {
            key: 'project_name',
            label: 'Project',
            width: 160,
            render: (v) => (
              <Typography variant="caption" sx={{ color: '#666' }} noWrap>{v.project_name || '—'}</Typography>
            )
          },
          {
            key: 'status',
            label: 'Status',
            width: 140,
            render: (v) => (
              <Chip label={statusConfig[v.status]?.label || v.status} size="small"
                sx={{ bgcolor: statusConfig[v.status]?.color, color: statusConfig[v.status]?.text, fontWeight: 600, height: 22, fontSize: 11 }} />
            )
          }
        ]}
        renderExpanded={(vendor) => (
          <Box>
            {/* Detail row */}
            <Box sx={{ display: 'flex', gap: 4, mb: 2, flexWrap: 'wrap' }}>
              {vendor.yaplar_vendor_id && (
                <Box>
                  <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>Vendor ID</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 700, color: '#1a237e', fontFamily: 'monospace' }}>
                    {vendor.yaplar_vendor_id}
                  </Typography>
                </Box>
              )}
              {(vendor.address || vendor.city || vendor.state || vendor.zip) && (
                <Box>
                  <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>Address</Typography>
                  <Typography variant="body2">
                    {[vendor.address, vendor.city, vendor.state, vendor.zip].filter(Boolean).join(', ')}
                  </Typography>
                </Box>
              )}
              {vendor.license_number && (
                <Box>
                  <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>License #</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {vendor.license_number}{vendor.license_expiry ? ' (exp ' + new Date(vendor.license_expiry).toLocaleDateString() + ')' : ''}
                  </Typography>
                </Box>
              )}
              {vendor.bank_name && (
                <Box>
                  <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>Bank</Typography>
                  <Typography variant="body2">{vendor.bank_name}{vendor.account_number_last4 ? ' ···· ' + vendor.account_number_last4 : ''}</Typography>
                </Box>
              )}
              {vendor.payment_method && (
                <Box>
                  <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>Payment method</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>{vendor.payment_method}</Typography>
                </Box>
              )}
              {user?.role !== 'general_contractor' && (
                <Box>
                  <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>GC Visibility</Typography>
                  <Chip label={vendor.visible_to_gc !== false ? 'GC Visible' : 'GC Hidden'} size="small"
                    sx={{ bgcolor: vendor.visible_to_gc !== false ? '#e8f5e9' : '#fff3e0', color: vendor.visible_to_gc !== false ? '#2e7d32' : '#e65100', fontSize: 11, fontWeight: 600 }} />
                </Box>
              )}
              <Box>
                <Typography variant="caption" sx={{ color: '#999', display: 'block' }}>Added</Typography>
                <Typography variant="body2">{new Date(vendor.created_at).toLocaleDateString()}</Typography>
              </Box>
            </Box>

            {/* Actions */}
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-start', borderTop: '1px solid #f0f0f0', pt: 1.5 }}>
              <Button size="small" variant="outlined" startIcon={<VisibilityIcon />}
                onClick={() => setViewDialog({ open: true, vendor })}
                sx={{ borderRadius: 2, fontSize: 11 }}>
                View Details
              </Button>
              {vendor.status === 'pending_approval' && (
                <Button size="small" variant="contained" startIcon={<CheckCircleIcon />}
                  onClick={() => handleApprove(vendor)}
                  sx={{ bgcolor: '#2e7d32', borderRadius: 2, fontSize: 11 }}>
                  Approve
                </Button>
              )}
              {vendor.status === 'inactive' ? (
                <Button size="small" variant="outlined" startIcon={<CheckCircleIcon />}
                  onClick={() => handleActivate(vendor)}
                  sx={{ borderRadius: 2, fontSize: 11, borderColor: '#2e7d32', color: '#2e7d32' }}>
                  Reactivate
                </Button>
              ) : (
                <Button size="small" variant="outlined" startIcon={<BlockIcon />}
                  onClick={() => handleDeactivate(vendor)}
                  sx={{ borderRadius: 2, fontSize: 11, borderColor: '#e53935', color: '#e53935' }}>
                  Deactivate
                </Button>
              )}
              <Button size="small" variant="outlined" startIcon={<EditIcon />}
                onClick={() => { setEditForm({ ...vendor, trade_specialties: vendor.trade_specialties || [] }); setEditPhoto([]); setEditDialog(true); }}
                sx={{ borderRadius: 2, fontSize: 11 }}>
                Edit
              </Button>
            </Box>
          </Box>
        )}
      />

      {/* Add Manually Dialog */}
      <Dialog open={manualDialog} onClose={() => setManualDialog(false)} maxWidth="sm" fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ bgcolor: '#1a237e', color: 'white', fontWeight: 700 }}>Add Vendor Manually</DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }}>Fill in the vendor details on their behalf. They will be automatically approved.</Alert>
          <Stepper activeStep={manualStep} sx={{ mb: 3 }}>
            {STEPS.map(l => <Step key={l}><StepLabel>{l}</StepLabel></Step>)}
          </Stepper>

          {manualStep === 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Project</InputLabel>
                <Select value={manualForm.project_id} onChange={e => setManualForm({...manualForm, project_id: e.target.value})}
                  label="Project" sx={{ borderRadius: 2 }}>
                  {projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
                </Select>
              </FormControl>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField fullWidth label="Company Name *" value={manualForm.company_name} onChange={e => setManualForm(prev => ({...prev, company_name: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                <TextField fullWidth label="Contact Name *" required type="text" value={manualForm.contact_name} onChange={e => setManualForm(prev => ({...prev, contact_name: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField fullWidth label="Email *" type="email" value={manualForm.email} onChange={e => setManualForm(prev => ({...prev, email: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                <TextField fullWidth label="Phone *" required type="text" value={manualForm.phone} onChange={e => setManualForm(prev => ({...prev, phone: formatPhone(e.target.value)}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              </Box>
              <Box>
                <Typography variant="caption" sx={{ color: '#666', fontWeight: 600 }}>Trade / Category *</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                  {(tradeOptions.length ? tradeOptions : TRADES).map(t => {
                    const sel = (manualForm.trade_specialties||[]).includes(t);
                    return <Chip key={t} label={t} size="small" clickable
                      onClick={() => { const arr = sel ? (manualForm.trade_specialties||[]).filter(x=>x!==t) : [...(manualForm.trade_specialties||[]),t]; setManualForm({...manualForm, trade_specialties: arr, trade_specialty: arr[0]||''}); }}
                      sx={{ bgcolor: sel?'#1a237e':'#f5f5f5', color: sel?'white':'#555', fontWeight: sel?700:400, border: sel?'none':'1px solid #e0e0e0' }}/>;
                  })}
                </Box>
              </Box>
              <TextField fullWidth label="Address" type="text" value={manualForm.address} onChange={e => setManualForm(prev => ({...prev, address: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField fullWidth label="City" type="text" value={manualForm.city} onChange={e => setManualForm(prev => ({...prev, city: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                <TextField fullWidth label="State" type="text" value={manualForm.state} onChange={e => setManualForm(prev => ({...prev, state: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                <TextField fullWidth label="ZIP" type="text" value={manualForm.zip} onChange={e => setManualForm(prev => ({...prev, zip: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              </Box>
              <TextField fullWidth label="Notes" type="text" value={manualForm.notes} onChange={e => setManualForm(prev => ({...prev, notes: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, bgcolor: '#f5f6fa', borderRadius: 2 }}>
                <Box>
                  <Typography variant="body2" fontWeight={700}>Visible to General Contractor</Typography>
                  <Typography variant="caption" color="text.secondary">GC can see this vendor's contracts, invoices and transactions</Typography>
                </Box>
                <Switch checked={manualForm.visible_to_gc !== false} onChange={e => setManualForm({...manualForm, visible_to_gc: e.target.checked})} color="primary" />
              </Box>
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a237e', mb: 1 }}>Company Photo / Logo (optional)</Typography>
                {manualForm.photo_url && <Box sx={{ mb: 1 }}><img src={manualForm.photo_url} alt="preview" style={{ width: 80, height: 80, borderRadius: 8, objectFit: 'cover' }} /></Box>}
                <FileUpload onFilesChange={setVendorPhoto} accept="image/*" />
              </Box>
            </Box>
          )}

          {manualStep === 1 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField fullWidth label="License Number" type="text" value={manualForm.license_number} onChange={e => setManualForm(prev => ({...prev, license_number: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                <TextField fullWidth label="License Expiry" type="date" value={manualForm.license_expiry} InputLabelProps={{ shrink: true }} onChange={e => setManualForm(prev => ({...prev, license_expiry: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              </Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a237e' }}>Insurance Certificate</Typography>
              <FileUpload onFilesChange={setInsuranceFiles} />
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a237e', mt: 1 }}>W9 / Tax Form</Typography>
              <FileUpload onFilesChange={setW9Files} />
            </Box>
          )}

          {manualStep === 2 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Payment Method</InputLabel>
                <Select value={manualForm.payment_method} onChange={e => setManualForm({...manualForm, payment_method: e.target.value})}
                  label="Payment Method" sx={{ borderRadius: 2 }}>
                  <MenuItem value="check">🖊️ Check</MenuItem>
                  <MenuItem value="ach">🏦 ACH / Bank Transfer</MenuItem>
                  <MenuItem value="zelle">⚡ Zelle</MenuItem>
                  <MenuItem value="wire">🔗 Wire Transfer</MenuItem>
                </Select>
              </FormControl>
              {(manualForm.payment_method === 'ach' || manualForm.payment_method === 'wire') && (
                <>
                  <TextField fullWidth label="Bank Name" type="text" value={manualForm.bank_name} onChange={e => setManualForm(prev => ({...prev, bank_name: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField fullWidth label="Routing Number" type="text" value={manualForm.routing_number} onChange={e => setManualForm(prev => ({...prev, routing_number: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                    <TextField fullWidth label="Last 4 of Account #" type="text" value={manualForm.account_number_last4} onChange={e => setManualForm(prev => ({...prev, account_number_last4: e.target.value}))} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                  </Box>
                </>
              )}
            </Box>
          )}

          {manualStep === 3 && (
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a237e', mb: 2 }}>Review Vendor Details</Typography>
              {[
                { label: 'Company', value: manualForm.company_name },
                { label: 'Contact', value: manualForm.contact_name },
                { label: 'Email', value: manualForm.email },
                { label: 'Phone', value: manualForm.phone },
                { label: 'Trade', value: manualForm.trade_specialty },
                { label: 'Address', value: [manualForm.address, manualForm.city, manualForm.state].filter(Boolean).join(', ') },
                { label: 'License #', value: manualForm.license_number },
                { label: 'Payment', value: manualForm.payment_method },
              ].filter(i => i.value).map((item, i) => (
                <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', py: 1, borderBottom: '1px solid #f5f6fa' }}>
                  <Typography variant="body2" sx={{ color: '#999' }}>{item.label}</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.value}</Typography>
                </Box>
              ))}
              <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                {insuranceFiles.length > 0 && <Chip label="✓ Insurance Uploaded" size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32' }} />}
                {w9Files.length > 0 && <Chip label="✓ W9 Uploaded" size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32' }} />}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1, borderTop: '1px solid #e8eaf6' }}>
          <Button onClick={() => setManualDialog(false)}>Cancel</Button>
          <Button disabled={manualStep === 0} onClick={() => setManualStep(s => s - 1)} sx={{ borderRadius: 2 }}>Back</Button>
          {manualStep < 3 ? (
            <Button variant="contained" onClick={() => setManualStep(s => s + 1)}
              disabled={manualStep === 0 && (!manualForm.company_name || !manualForm.email)}
              sx={{ bgcolor: '#1a237e', borderRadius: 2, px: 3 }}>Next</Button>
          ) : (
            <Button variant="contained" onClick={handleManualSubmit} disabled={loading}
              startIcon={<CheckCircleIcon />} sx={{ bgcolor: '#2e7d32', borderRadius: 2, px: 3 }}>
              {loading ? 'Saving...' : 'Add Vendor'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Invite Dialog */}
      <Dialog open={inviteDialog} onClose={() => setInviteDialog(false)} maxWidth="sm" fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ bgcolor: '#1a237e', color: 'white', fontWeight: 700 }}>Invite Vendor</DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>Send an onboarding email invite to a contractor or supplier.</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <FormControl fullWidth>
              <InputLabel>Project</InputLabel>
              <Select value={inviteForm.project_id} onChange={e => setInviteForm({...inviteForm, project_id: e.target.value})}
                label="Project" sx={{ borderRadius: 2 }}>
                {projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
              </Select>
            </FormControl>
            <TextField fullWidth label="Company Name *" value={inviteForm.company_name}
              onChange={e => setInviteForm({...inviteForm, company_name: e.target.value})}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField fullWidth label="Contact Name *" required value={inviteForm.contact_name}
                onChange={e => setInviteForm({...inviteForm, contact_name: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              <TextField fullWidth label="Phone *" required value={inviteForm.phone}
                onChange={e => setInviteForm({...inviteForm, phone: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            </Box>
            <TextField fullWidth label="Email Address *" type="email" value={inviteForm.email}
              onChange={e => setInviteForm({...inviteForm, email: e.target.value})}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            <FormControl fullWidth>
              <InputLabel>Trade Specialty</InputLabel>
              <Select value={inviteForm.trade_specialty || ''} onChange={e => setInviteForm({...inviteForm, trade_specialty: e.target.value})}
                label="Trade Specialty" sx={{ borderRadius: 2 }}>
                {(tradeOptions.length ? tradeOptions : TRADES).map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
              </Select>
            </FormControl>
            <TextField fullWidth label="Notes" multiline rows={2} value={inviteForm.notes}
              onChange={e => setInviteForm({...inviteForm, notes: e.target.value})}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button onClick={() => setInviteDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleInvite} disabled={loading || !inviteForm.company_name || !inviteForm.email}
            startIcon={<EmailIcon />} sx={{ bgcolor: '#1a237e', borderRadius: 2, px: 3 }}>
            {loading ? 'Sending...' : 'Send Invitation'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Vendor Dialog */}
      <Dialog open={viewDialog.open} onClose={() => setViewDialog({ open: false, vendor: null })}
        maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        {viewDialog.vendor && (
          <>
            <DialogTitle sx={{ bgcolor: '#1a237e', color: 'white', fontWeight: 700 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{viewDialog.vendor.company_name}</Typography>
                <Chip label={statusConfig[viewDialog.vendor.status]?.label} size="small"
                  sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 600 }} />
              </Box>
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <Grid container spacing={2}>
                {[
                  { label: 'Contact', value: viewDialog.vendor.contact_name },
                  { label: 'Email', value: viewDialog.vendor.email },
                  { label: 'Phone', value: viewDialog.vendor.phone },
                  { label: 'Trade', value: viewDialog.vendor.trade_specialty },
                  { label: 'Project', value: viewDialog.vendor.project_name },
                  { label: 'License #', value: viewDialog.vendor.license_number },
                ].map((item, i) => item.value && (
                  <Grid item xs={6} key={i}>
                    <Typography variant="caption" sx={{ color: '#999' }}>{item.label}</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.value}</Typography>
                  </Grid>
                ))}
              </Grid>
              {viewDialog.vendor.bank_name && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a237e', mb: 1 }}>Payment Info</Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: '#999' }}>Bank</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>{viewDialog.vendor.bank_name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" sx={{ color: '#999' }}>Method</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, textTransform: 'capitalize' }}>{viewDialog.vendor.payment_method}</Typography>
                    </Grid>
                  </Grid>
                </>
              )}
              {(viewDialog.vendor.insurance_cert_url || viewDialog.vendor.w9_url) && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a237e', mb: 1 }}>Documents</Typography>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {viewDialog.vendor.insurance_cert_url && (
                      <Button size="small" variant="outlined" href={viewDialog.vendor.insurance_cert_url} target="_blank" sx={{ borderRadius: 2 }}>📄 Insurance</Button>
                    )}
                    {viewDialog.vendor.w9_url && (
                      <Button size="small" variant="outlined" href={viewDialog.vendor.w9_url} target="_blank" sx={{ borderRadius: 2 }}>📄 W9</Button>
                    )}
                  </Box>
                </>
              )}
            </DialogContent>
            <DialogActions sx={{ p: 3, gap: 1 }}>
              <Button onClick={() => setViewDialog({ open: false, vendor: null })}>Close</Button>
              {viewDialog.vendor.status === 'pending_approval' && (
                <Button variant="contained" startIcon={<CheckCircleIcon />} onClick={() => handleApprove(viewDialog.vendor)}
                  sx={{ bgcolor: '#2e7d32', borderRadius: 2, px: 3 }}>Approve Vendor</Button>
              )}
              {viewDialog.vendor.status === 'inactive' && (
                <Button variant="contained" startIcon={<CheckCircleIcon />} onClick={() => { handleActivate(viewDialog.vendor); setViewDialog({open:false,vendor:null}); }}
                  sx={{ bgcolor: '#2e7d32', borderRadius: 2, px: 3 }}>Reactivate</Button>
              )}
              {viewDialog.vendor.status !== 'inactive' && viewDialog.vendor.status !== 'pending_approval' && (
                <Button variant="outlined" startIcon={<BlockIcon />} onClick={() => { handleDeactivate(viewDialog.vendor); setViewDialog({open:false,vendor:null}); }}
                  sx={{ borderColor: '#e53935', color: '#e53935', borderRadius: 2, px: 3 }}>Deactivate</Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Edit Vendor Dialog */}
      <Dialog open={editDialog} onClose={() => setEditDialog(false)} maxWidth="sm" fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ bgcolor: '#1a237e', color: 'white', fontWeight: 700 }}>Edit Vendor</DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField fullWidth label="Company Name *" value={editForm.company_name || ''}
                onChange={e => setEditForm({...editForm, company_name: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              <TextField fullWidth label="Contact Name *" required value={editForm.contact_name || ''}
                onChange={e => setEditForm({...editForm, contact_name: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField fullWidth label="Email" value={editForm.email || ''}
                onChange={e => setEditForm({...editForm, email: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              <TextField fullWidth label="Phone *" required value={editForm.phone || ''}
                onChange={e => setEditForm({...editForm, phone: formatPhone(e.target.value)})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            </Box>
            <FormControl fullWidth>
              <InputLabel>Trade / Categories</InputLabel>
              <Select multiple
                value={Array.isArray(editForm.trade_specialties) ? editForm.trade_specialties : editForm.trade_specialty ? [editForm.trade_specialty] : []}
                onChange={e => setEditForm({...editForm, trade_specialties: e.target.value, trade_specialty: e.target.value[0] || ''})}
                label="Trade / Categories" sx={{ borderRadius: 2 }}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map(v => <Chip key={v} label={v} size="small" sx={{ bgcolor: '#e8eaf6', color: '#1a237e' }} />)}
                  </Box>
                )}>
                {(tradeOptions.length ? tradeOptions : TRADES).map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
              </Select>
            </FormControl>
            <TextField fullWidth label="Address" value={editForm.address || ''}
              onChange={e => setEditForm({...editForm, address: e.target.value})}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField fullWidth label="City" value={editForm.city || ''}
                onChange={e => setEditForm({...editForm, city: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              <TextField fullWidth label="State" value={editForm.state || ''}
                onChange={e => setEditForm({...editForm, state: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              <TextField fullWidth label="ZIP" value={editForm.zip || ''}
                onChange={e => setEditForm({...editForm, zip: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField fullWidth label="License Number" value={editForm.license_number || ''}
                onChange={e => setEditForm({...editForm, license_number: e.target.value})}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              <TextField fullWidth label="License Expiry" type="date" value={editForm.license_expiry?.split('T')[0] || ''}
                onChange={e => setEditForm({...editForm, license_expiry: e.target.value})}
                InputLabelProps={{ shrink: true }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            </Box>
            <FormControl fullWidth>
              <InputLabel>Payment Method</InputLabel>
              <Select value={editForm.payment_method || 'check'} onChange={e => setEditForm({...editForm, payment_method: e.target.value})}
                label="Payment Method" sx={{ borderRadius: 2 }}>
                <MenuItem value="check">🖊️ Check</MenuItem>
                <MenuItem value="ach">🏦 ACH / Bank Transfer</MenuItem>
                <MenuItem value="zelle">⚡ Zelle</MenuItem>
                <MenuItem value="wire">🔗 Wire Transfer</MenuItem>
              </Select>
            </FormControl>
            <TextField fullWidth label="Notes" multiline rows={2} value={editForm.notes || ''}
              onChange={e => setEditForm({...editForm, notes: e.target.value})}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            <Box>
              <Typography variant="caption" sx={{ color: '#666', fontWeight: 600 }}>Trade / Category</Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                {(tradeOptions.length ? tradeOptions : TRADES).map(t => {
                  const sel = (Array.isArray(editForm.trade_specialties) ? editForm.trade_specialties : []).includes(t);
                  return <Chip key={t} label={t} size="small" clickable
                    onClick={() => { const arr = sel ? editForm.trade_specialties.filter(x=>x!==t) : [...(editForm.trade_specialties||[]),t]; setEditForm({...editForm, trade_specialties: arr, trade_specialty: arr[0]||''}); }}
                    sx={{ bgcolor: sel?'#1a237e':'#f5f5f5', color: sel?'white':'#555', fontWeight: sel?700:400, border: sel?'none':'1px solid #e0e0e0' }}/>;
                })}
              </Box>
            </Box>
            {user?.role !== 'general_contractor' && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, bgcolor: '#f5f6fa', borderRadius: 2 }}>
              <Box>
                <Typography variant="body2" fontWeight={700}>Visible to General Contractor</Typography>
                <Typography variant="caption" color="text.secondary">GC can see this vendor's transactions</Typography>
              </Box>
              <Switch checked={editForm.visible_to_gc !== false} onChange={e => setEditForm({...editForm, visible_to_gc: e.target.checked})} color="primary" />
            </Box>}
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a237e', mb: 1 }}>Company Photo / Logo (optional)</Typography>
              {editForm.photo_url && <Box sx={{ mb: 1 }}><img src={editForm.photo_url} alt="current" style={{ width: 80, height: 80, borderRadius: 8, objectFit: 'cover' }} /></Box>}
              <FileUpload onFilesChange={setEditPhoto} accept="image/*" />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button onClick={() => setEditDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={async () => {
            const photoUrl = editPhoto.length > 0 ? (editPhoto[0].url || editPhoto[0].gcsUrl) : editForm.photo_url;
            await api.put('/vendors/' + editForm.id, {...editForm, photo_url: photoUrl});
            setVendors(vs => vs.map(v => v.id===editForm.id ? {...v,...editForm, photo_url: photoUrl} : v));
            setEditDialog(false);
          }} disabled={loading}
            startIcon={<EditIcon />} sx={{ bgcolor: '#1a237e', borderRadius: 2, px: 3 }}>
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogActions>
      </Dialog>

    </Layout>
  );
}
